import { useCallback, useMemo } from "react";
import { createTrackingUtils } from "../index";
import useRouteName from "../../../hooks/useRouteName";
import useProfiler from "../../../hooks/useProfiler";
import useVirutalInterlining from "../../../hooks/useVirutalInterlining";
import { useSelector } from "react-redux";
import { getFlightDetailsSegments } from "../../../store/flightDetails/selectors";
import { getOrder } from "../../../store/order/selectors";

const util = createTrackingUtils({
  name: "flights_web_mdot_cnp_condensed",
  defaultStage: 1,
  stages: {
    main: 1,
    vi: 2,
    sirf: 3,
    cancel24: 4,
    ancillary: 5,
    solo: 6,
    nonsolo: 7
  },
  goals: {
    clickDetails: 1,
    clickExtras: 2
  }
});

export default util;

export function useFlightsWebMdotCnpCondensed(isSirf: boolean) {
  const routeName = useRouteName();
  const { isMobile, isSolo } = useProfiler();
  const { isVirtualInterliningFlight } = useVirutalInterlining();
  const flightSegments = useSelector(getFlightDetailsSegments);
  const order = useSelector(getOrder);

  const isVi = useMemo(() => {
    return isVirtualInterliningFlight(flightSegments || []);
  }, [isVirtualInterliningFlight, flightSegments]);

  const trackStages = useCallback(() => {
    if (!["checkout-payment", "checkout-sirf"].includes(routeName)) return;
    if (!isMobile()) return;
    util.stages.main();
    if (isVi) util.stages.vi();
    if (isSirf) util.stages.sirf();
    if (order?.isCancellableWithin24Hours) util.stages.cancel24();
    if (Object.keys(order?.ancillaries || {}).length > 0) util.stages.ancillary();
    if (isSolo()) util.stages.solo();
    if (!isSolo()) util.stages.nonsolo();
  }, [isSirf, routeName, isMobile, isSolo, isVi, order]);

  return { trackStages };
}
